import { ProblemDetails } from "../ProblemDetails";

export class NotFoundError extends Error {
  constructor(problemDetails: ProblemDetails) {
    super();
    this.problemDetails = problemDetails;
  }

  problemDetails: ProblemDetails;
}